export class ApPortConfiguration {
    port: number;
    label: string;
    untaggedLogicalNetworkId: number;
    taggedLogicalNetworkIds: number[];
    default_config: boolean;
}
